/**
 * Environment utilities for resolving API base URL
 * In production, uses window.location.origin so a single build works on any domain
 */

const DEFAULT_API_FALLBACK = "http://localhost:8000";

const trimTrailingSlash = (value: string): string => value.replace(/\/+$/, "");

const normalizeEnvValue = (value?: string): string | undefined => {
  const trimmed = value?.trim();
  return trimmed ? trimTrailingSlash(trimmed) : undefined;
};

export function resolveApiBaseUrl(): string {
  const apiHost = normalizeEnvValue(import.meta.env.VITE_API_HOST);
  const proxyTarget = normalizeEnvValue(import.meta.env.VITE_API_PROXY_TARGET);

  // Explicit API URL ensures CRM and all SDK calls reach the backend (works with proxy
  // and direct; VITE_API_PROXY_TARGET is the API server the proxy forwards to)
  const explicitApiUrl = proxyTarget || apiHost;
  if (explicitApiUrl) {
    return explicitApiUrl;
  }

  // In production with no explicit config, use window origin (single build, any domain)
  const origin =
    typeof window !== "undefined" ? window.location.origin : undefined;
  if (origin && import.meta.env.PROD) {
    return trimTrailingSlash(origin);
  }

  // Final fallback for development/testing
  return DEFAULT_API_FALLBACK;
}
